// RITA-1522 (Nutzungserfassung Phase 3d, Epic RITA-1496) — Context des Overlays.
//
// Eigenes Modul, weil der Provider seine beiden Kinder (Zeichenfläche und Leiste) selbst einhängt
// und diese denselben Zustand lesen: läge der Context in HeatmapProvider.tsx, importierten sich
// die drei Dateien im Kreis (ESLint import/no-cycle).
import { createContext, useContext } from 'react';
import { ApolloError } from '@apollo/client';
import type { UsageClickMap, UsageDays } from '../types';

/** Vorgabe des Zeitraums — wie auf der Auswertungsseite. */
export const HEATMAP_STANDARD_ZEITRAUM: UsageDays = 30;

export interface HeatmapZustand {
  /** Darf diese Person das Overlay überhaupt benutzen? (angemeldet UND SUPERADMIN) */
  verfuegbar: boolean;
  enabled: boolean;
  setEnabled: (next: boolean) => void;
  days: UsageDays;
  setDays: (tage: UsageDays) => void;
  /** Gewählte Fensterklasse; Vorgabe ist die eigene. */
  viewportClassLabel: string;
  setViewportClassLabel: (label: string) => void;
  /**
   * Klasse des EIGENEN Fensters — sie folgt der Fensterbreite. Die Auswahl macht sie damit
   * kenntlich: nur solange sie gewählt ist, geht die echte Breite hinaus, jede andere Wahl
   * schickt die repräsentative Breite ihrer Klasse.
   */
  eigenesKlassenLabel: string;
  /** Routen-Muster der aktuellen Seite; 'unbekannt' heißt: für diese Seite gibt es keine Karte. */
  route: string;
  /** Antwort der Klickkarte — geteilt von Zeichenfläche und Leiste. */
  karte: UsageClickMap | null;
  loading: boolean;
  error: ApolloError | undefined;
  erneutVersuchen: () => void;
}

/** Ausgangszustand außerhalb des Providers: alles aus, nichts wirft. */
const leererZustand: HeatmapZustand = {
  verfuegbar: false,
  enabled: false,
  setEnabled: () => undefined,
  days: HEATMAP_STANDARD_ZEITRAUM,
  setDays: () => undefined,
  viewportClassLabel: '',
  setViewportClassLabel: () => undefined,
  eigenesKlassenLabel: '',
  route: '',
  karte: null,
  loading: false,
  error: undefined,
  erneutVersuchen: () => undefined,
};

export const HeatmapContext = createContext<HeatmapZustand>(leererZustand);

/** Zustand des Overlays. Außerhalb des Providers ist alles aus — nichts wirft. */
export const useHeatmap = (): HeatmapZustand => useContext(HeatmapContext);
